import { NavItem } from './nav-item';

export class HelpNavItem extends NavItem {}
